export default __webpack_public_path__ + "static/media/approved_disabled.b6d511a7.svg";